module.exports = __webpack_public_path__ + "img/数字.b95dc301.png";